import styled from 'styled-components'
import tw from 'twin.macro'

import { isPresent } from 'utils'

export const Root = styled.div`
  ${tw`relative`};
`

export const Label = styled.label`
  ${tw`block absolute top-0 left-0 z-10`};
  transform: translateY(-0.5rem);

  color: ${({ $error }) => (isPresent($error) ? 'var(--color-danger)' : 'var(--color-blue-grey)')};
`
